import React from 'react';
import { List } from 'antd-mobile';
import { MailOutline, ExclamationCircleOutline, CheckCircleOutline, RightOutline } from 'antd-mobile-icons';
import { useNavigate } from 'react-router-dom';
import { useTenant } from '@/features/tenant/context/TenantContext';

export const MailActionMenu: React.FC = () => {
    const navigate = useNavigate();
    const { tenantCode } = useTenant();

    const menuItems = [
        {
            key: 'inbox',
            title: '收件箱',
            icon: <MailOutline className="text-blue-400" fontSize={24} />,
            onClick: () => navigate(`/${tenantCode}/mail?filter=all`),
        },
        {
            key: 'action-required',
            title: '需要处理',
            icon: <ExclamationCircleOutline className="text-yellow-400" fontSize={24} />,
            onClick: () => navigate(`/${tenantCode}/mail?filter=action`),
        },
        {
            key: 'completed',
            title: '最近已完成',
            icon: <CheckCircleOutline className="text-green-400" fontSize={24} />,
            onClick: () => navigate(`/${tenantCode}/mail?filter=completed`),
        },
    ];

    return (
        <div className="glass rounded-2xl overflow-hidden">
            <List>
                {menuItems.map((item, index) => (
                    <List.Item
                        key={item.key}
                        prefix={item.icon}
                        arrow={<RightOutline className="text-gray-500" />}
                        onClick={item.onClick}
                        className={`
                            active:bg-white/5 transition-colors
                        `}
                    >
                        <span className="text-base font-medium">{item.title}</span>
                    </List.Item>
                ))}
            </List>
        </div>
    );
};
